import { Injectable, inject } from '@angular/core';
import { WebStorageService } from '@pedix-workspace/pedixapp-core-services';

const STORAGE_OPTIONS = {
  storageType: 'session',
  prefix: 'pedixapp',
  namespace: 'repeated-orders',
} as const;

export const REPEAT_ORDER_REMOVED_NAMES_STATE_KEY = 'repeatOrderRemovedNames';

@Injectable({ providedIn: 'root' })
export class RepeatOrderStateService {
  private webStorage = inject(WebStorageService);

  wasRepeated(establishmentId: string, orderId: string): boolean {
    return this.getRepeatedOrderIds(establishmentId).includes(orderId);
  }

  markRepeated(establishmentId: string, orderId: string) {
    const repeatedOrderIds = this.getRepeatedOrderIds(establishmentId);

    if (repeatedOrderIds.includes(orderId)) {
      return;
    }

    this.webStorage.setItem(establishmentId, [...repeatedOrderIds, orderId], STORAGE_OPTIONS);
  }

  private getRepeatedOrderIds(establishmentId: string): string[] {
    return this.webStorage.getItem<string[]>(establishmentId, STORAGE_OPTIONS) ?? [];
  }
}
